var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefultPatientIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-default_patient_icon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 18
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "default_patient_icon",
    "data-name": "default patient icon",
    clipPath: "url(#clip-default_patient_icon)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4100",
    "data-name": "Group 4100",
    transform: "translate(-10.162 -1136.933)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6335",
    "data-name": "Path 6335",
    d: "M15.823,1165.184a1.188,1.188,0,0,0-.7,1.2c0,.66.36,1.184.831,1.227a4.524,4.524,0,0,0,1.549,2.433l-.121,1.044a.574.574,0,0,1-.41.486l-2.631.764a2.491,2.491,0,0,0-1.032.54,3.04,3.04,0,0,0-1.045,1.746l-.617,3.091a.146.146,0,0,0,.03.124.15.15,0,0,0,.115.053h15.6a.15.15,0,0,0,.115-.053.146.146,0,0,0,.03-.124l-.617-3.091a3.04,3.04,0,0,0-1.045-1.746,2.491,2.491,0,0,0-1.032-.54l-2.631-.764a.574.574,0,0,1-.41-.486l-.121-1.044a4.524,4.524,0,0,0,1.549-2.433c.471-.043.831-.567.831-1.227a1.188,1.188,0,0,0-.7-1.2",
    transform: "translate(0 -23.432)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6336",
    "data-name": "Path 6336",
    d: "M45.644,1141.745s.218-4.374-3.714-4.374-3.735,4.381-3.735,4.381",
    transform: "translate(-22.372 0)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6337",
    "data-name": "Path 6337",
    d: "M39.981,1149.177a1.4,1.4,0,0,1,.781-.674,2.215,2.215,0,0,1,1.645.2,7.219,7.219,0,0,0,2.23.832,3.822,3.822,0,0,0,2.239-.365",
    transform: "translate(-23.878 -9.304)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_705",
    "data-name": "Line 705",
    x2: 2.43,
    y2: 2.52,
    transform: "translate(17.128 1148.072)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_706",
    "data-name": "Line 706",
    x1: 2.43,
    y2: 2.52,
    transform: "translate(19.558 1148.072)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6338",
    "data-name": "Path 6338",
    d: "M45.287,1210.276l-2.248,2.382a.628.628,0,0,1-.9,0l-2.248-2.382-.917.279,3.6,3.854.01-.01.01.01,3.6-3.854Z",
    transform: "translate(-23.033 -61.421)",
    fill: "#6c5b7b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefultPatientIcon);
export default __webpack_public_path__ + "static/media/defultPatientIcon.95634b5bce8a6bbf1d991b78c7ba0b3c.svg";
export { ForwardRef as ReactComponent };